<template>
  <span>
    <div>
      {{ paymentStructureText }}
    </div>
    <div v-if="eventProduct.registrationEndDate">
      <strong
        :class="{
          'text-red': $dayjs($dayjs().format('YYYY-MM-DD')).isSameOrBefore(
            eventProduct.registrationEndDate
          )
        }"
        >{{ paymentDeadlineText }}:
        {{ $dayjs.date(eventProduct.registrationEndDate) }}</strong
      >
    </div>
    <div
      v-if="
        eventProduct.limitNumberOfProductsPerRegistration &&
        eventProduct.limitNumberOfProductsPerRegistration > 0
      "
      class="my-2"
    >
      {{
        $t(
          [
            "events:products.productsPerRegistration.text",
            "Up to {\{limitNumberOfProductsPerRegistration}\} per registration"
          ],
          {
            limitNumberOfProductsPerRegistration:
              eventProduct.limitNumberOfProductsPerRegistration
          }
        )
      }}
    </div>
  </span>
</template>
<script>
import gql from "fraql";
export default {
  name: "ShowPaymentStructure",
  props: {
    eventProduct: {
      type: Object,
      required: true
    }
  },
  fragments: {
    eventProduct: gql`
      fragment _ on EventProduct {
        paymentStructure
        registrationEndDate
        limitNumberOfProductsPerRegistration
      }
    `
  },
  computed: {
    paymentStructureText() {
      switch (this.eventProduct.paymentStructure) {
        case "fully_during_competition_no_booking":
          return this.$t(
            "events:EventPage.products.Condition.FullyDuringCompetition",
            "Full price paid during competition, no booking",
            "Payment condition in products section in registration form"
          );
        case "fully_during_competition_free_booking":
          return this.$t(
            "events:EventPage.products.Condition.FullyDuringCompetitionFreeBooking",
            "Full price paid during competition, booking online for free",
            "Payment condition in products section in registration form"
          );
        case "full_price_online_booking_nonrefundable":
          return this.$t(
            "events:EventPage.products.Condition.FullPriceOnlineBookingNonrefundable",
            "Full price paid online, booking fee is non-refundable",
            "Payment condition in products section in registration form"
          );
        case "full_price_online_no_refund":
          return this.$t(
            "events:EventPage.products.Condition.FullPriceOnline",
            "Full price paid online, price is non-refundable",
            "Payment condition in products section in registration form"
          );
        default:
          return "";
      }
    },
    paymentDeadlineText() {
      switch (this.eventProduct.paymentStructure) {
        case "fully_during_competition_no_booking":
        case "fully_during_competition_free_booking":
          return this.$t(
            "events:EntryForm.ProductsSection.eventProduct.paymentStructureWithoutOnlinePayment.registrationEndDate.label",
            "Registration deadline"
          );
        default:
          return this.$t(
            "events:EntryForm.ProductsSection.eventProduct.paymentStructureWithOnlinePayment.registrationEndDate.label",
            "Payment deadline"
          );
      }
    }
  }
};
</script>
